var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.735 11.0712L6.27391 0.610166C5.88247 0.219307 5.35198 0 4.79904 0C4.24591 0 3.71541 0.219316 3.32398 0.610166L0.612295 3.32452C0.220465 3.7148 0 4.24512 0 4.79805C0 5.35118 0.220475 5.88149 0.612295 6.27178L11.0625 16.7328L17.8691 18L16.735 11.0712ZM15.5844 12.6459L15.8977 14.559L14.4948 15.962L12.6179 15.6127L15.5844 12.6459ZM7.70733 4.00633L4.00044 7.71342L3.69545 7.40843L7.40234 3.70134L7.70733 4.00633ZM1.3804 4.80216C1.38021 4.61688 1.45409 4.43915 1.5856 4.3086L4.30268 1.59152C4.43632 1.46446 4.61347 1.39367 4.79759 1.39367C4.9819 1.39367 5.15905 1.46446 5.2925 1.59152L6.4349 2.72001L2.7141 6.42691L1.58561 5.29841C1.45332 5.16729 1.37943 4.98839 1.3804 4.80216ZM4.98481 8.68368L8.6863 4.98783L14.9885 11.287L11.2816 14.9939L4.98481 8.68368Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.6c742ff1ca6cbc4a051ec17eea1b1080.svg";
export { ForwardRef as ReactComponent };